import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { CssBaseline } from "@mui/material";
import Login from "./auth";
import Dashboard from "./screens/dashboard/Dashboard";
import Sales from "./screens/sales/Sales";
import CaseDetails from "./screens/cases/CaseDetails";
import { CaseIndex } from "./screens/cases/CaseIndex";
import Case from "./screens/cases/Case";
import { ProgramsIndex } from "./screens/programs/ProgramsIndex";
import Programs from "./screens/programs/Programs";
import { SalesIndex } from "./screens/sales/SalesIndex";
import { SuportIndex } from "./screens/supports/SupportIndex";
import Support from "./screens/supports/Support";
import { CommonProvider } from "./context/CommonContext";
import { SettingsIndex } from "./screens/settings/SettingsIndex";
import Settings from "./screens/settings/Settings";
import { Index } from "./layout/Index";
import { RecoilRoot } from "recoil";
import InvoicePage from "./screens/invoice/Invoice";
import { InvoiceIndex } from "./screens/invoice/InvoiceIndex";
import Themeprovider from "./theame/Themeprovider";
import { TaskIndex } from "./screens/task/TaskIndex";
import Task from "./screens/task/Task";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('accessToken');
  if (!token) {
    return <Navigate to="/" replace />;
  }
  return children;
};

const PublicRoute = ({ children }) => {
  const token = localStorage.getItem('accessToken');
  if (token) {
    return <Navigate to="/admin/dashboard" replace />;
  }
  return children;
};

function App() {
  useEffect(() => {
    // One-time cleanup for old localStorage keys
    localStorage.removeItem("weightWondor");
    localStorage.removeItem("profile");
  }, []);

  return (
    <div className="flex flex-col flex-1 h-screen">
      <RecoilRoot>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Themeprovider>
            <CommonProvider>
              <CssBaseline />
              <Router>
                <Routes>
                  <Route path="/" element={<PublicRoute><Login /></PublicRoute>} />
                  <Route path="/admin" element={<ProtectedRoute><Index /></ProtectedRoute>}>
                    <Route path="dashboard" element={<Dashboard />} />
                    {/* cases paths  */}
                    <Route path="cases" element={<CaseIndex />}>
                      <Route path="" element={<Case />} />
                      <Route path="caseDetails/:id" element={<CaseDetails />} />
                    </Route>

                    {/* sales paths  */}
                    <Route path="sales" element={<SalesIndex />}>
                      <Route path="" element={<Sales />} />
                    </Route>
                    {/* <Route path="edit-user/:id" element={<EditUserDialog />} /> */}
                    {/* Program paths  */}
                    <Route path="programs" element={<ProgramsIndex />}>
                      <Route path="" element={<Programs />} />
                    </Route>
                    {/* Support Paths  */}
                    <Route path="support" element={<SuportIndex />}>
                      <Route path="" element={<Support />} />
                    </Route>
                    {/* Settings Paths  */}
                    <Route path="settings" element={<SettingsIndex />}>
                      <Route path="" element={<Settings />} />
                    </Route>
                    {/* Task Paths */}
                    <Route path="task" element={<TaskIndex />}>
                      <Route path="" element={<Task />} />
                    </Route>
                    {/* invoice Paths  */}
                    <Route path="invoice" element={<InvoiceIndex />}>
                      <Route path=":invoiceId" element={<InvoicePage />} />
                    </Route>
                  </Route>
                  {/* Catch-all route to redirect based on auth status */}
                  <Route
                    path="*"
                    element={
                      <Navigate
                        to={
                          localStorage.getItem("accessToken")
                            ? "/admin/dashboard"
                            : "/"
                        }
                        replace
                      />
                    }
                  />
                </Routes>
              </Router>
            </CommonProvider>
          </Themeprovider>
        </LocalizationProvider>
      </RecoilRoot>
    </div>
  );
}

export default App;
